// Header.js
import './Header.css'; // Optional: add CSS for styling
import axios from "axios";
import React, { useState, useEffect, useRef } from 'react';
import { baseUrl } from '../shared';
import { useNavigate } from "react-router-dom";
import { useAuth } from './useAuth';
import { getGlobalVariable } from '../shared';
import ReactDOM from 'react-dom';
import HelpDetails from './HelpDetails';
import { createRoot } from 'react-dom/client';
import SettingsPopup from "./SettingsPopup";
import GoogleTranslate from "../components/GoogleTranslate";

function Header({ studentName, Sdata,studentInfo  }) {
  const DPImage = require('../icons/DP.png');
  const HelpIcon = require('../icons/helpnew.png')
  const [isHelpEnabled, setIsHelpEnabled] = useState(false);
  const [currentSSODateTime, setCurrentSSODateTime] = useState(new Date());

  useEffect(() => {
    const checkGlobalVariable = () => {
      const intValue = parseInt(getGlobalVariable(), 10); // Convert to integer
      setIsHelpEnabled(!isNaN(intValue) && intValue > 0); // Enabled if valid integer > 0
    };
    checkGlobalVariable();

    const interval = setInterval(checkGlobalVariable, 100);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const popoverRef = useRef(null); // Ref for the popover container

  const handleImageClick = () => {
    // setIsPopoverVisible(!isPopoverVisible);
  };

  const [helpData, setHelpData] = useState([]);
  const [searchOptions, setSearchOptions] = useState([]);
  const [distinctCategory, setDistinctCategory] = useState([]);

  const handleHelpClick = () => {
    const intValue = parseInt(getGlobalVariable(), 10);
    const studentkey = sessionStorage.getItem("studentkey");
    const districtID = sessionStorage.getItem("districtID");
    const token = sessionStorage.getItem("authToken");
    const headers = {
      'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
      'Content-Type': 'application/json', // Optional: Define the content type if needed
    };

    if (!intValue) {
      alert('Help Page ID is not available yet. Please try again later.');
      return;
    }

    axios
      .get(baseUrl + `Student/GetHelpPageDetails?studentkey=${studentkey}&districtId=${districtID}&pageId=${intValue}`, { headers })
      .then((response) => {
        const data = response.data;
        if (data.data0) {
          const helpList = data.data1.map((item) => ({
            helpTitle: item.Title,
            helpHTML: item.HTML,
            helpPDF: item.PDF,
            helpCategory: item.Category,
            helpID: item.HelpID,
            pageID: item.PageID,
            helpDescription: item.Description,
            rating: item.Rating,
            overallRating: item.OverallRating,
          }));
          const categories = [
            ...new Set(helpList.map((item) => item.helpCategory)),
          ].map((category) => ({
            text: category,
            value: category,
          }));

          const sortedCategories = categories.sort((a, b) =>
            a.text.localeCompare(b.text)
          );

          // Store data in state
          setHelpData(helpList);
          setSearchOptions(sortedCategories);
          setDistinctCategory(sortedCategories);

          openHelpDetailsInNewWindow(helpList, sortedCategories);
        } else {
          alert("No data found for the requested Help Page.");
        }
      })
      .catch((error) => {
        console.error("Error fetching Help details:", error);
        alert("Failed to fetch Help details.");
      });
  };

  const openHelpDetailsInNewWindow = (helpList, categories) => {
    const newWindow = window.open('', '_blank', 'width=800, height=600');

    if (!newWindow) {
      alert('Unable to open new window.');
      return;
    }

    newWindow.document.write('<div id="new-window-root"></div>');

    const link = newWindow.document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap';
    newWindow.document.head.appendChild(link);

    const containerCheckInterval = setInterval(() => {
      const container = newWindow.document.getElementById('new-window-root');
      if (container) {
        clearInterval(containerCheckInterval); // Stop checking once container exists

        const root = createRoot(container);
        root.render(
          <React.StrictMode>
            <HelpDetails helpData={helpList} distinctCategory={categories} />
          </React.StrictMode>
        );
      }
    }, 100);

    newWindow.addEventListener('unload', () => clearInterval(containerCheckInterval));
  };

  const [studntIdData, setstudntIdData] = useState();
  const [TsdsStudentIdData, setTsdsStudentIdData] = useState();
  const [DOB, setDOB] = useState();
  const [SchoolYear, setSchoolYear] = useState();
  const [currentDateTime, setCurrentDateTime] = useState("");
  let date = "";
  useEffect(() => {
    if (studentInfo) {     
      setstudntIdData(studentInfo.data2[0].StudentId);
          setTsdsStudentIdData(studentInfo.data2[0].TsdsStudentId);
          let dateStr = new Date(studentInfo.data2[0].DOB);
          dateStr.toLocaleDateString();
          console.log(dateStr.toLocaleDateString());
          date = dateStr.toLocaleDateString();
          setDOB(date);
          setSchoolYear(studentInfo.data2[0].SchoolYear);
    }
  }, [studentInfo]);

  useEffect(() => {
    setCurrentSSODateTime(new Date());
    const updateDateTime = () => {
      const options = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      };
      setCurrentDateTime(new Date().toLocaleString('en-US', options));
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    const savedUser = sessionStorage.getItem('ClassLinkLogin');
    if(savedUser != null){
      const token = sessionStorage.getItem("authToken");
      const headers = {
        'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        'Content-Type': 'application/json', // Optional: Define the content type if needed
      };
      const requestData = {
        DistrictID: Sdata.data.districtID,
        UserId: Sdata.userId,
        TenentId: Sdata.tenentId,
        LoginId: Sdata.studentId,
        StudentName: Sdata.data.firstName,
        Role: Sdata.role,
        ErrorMessage:null,
        LoginTime:null,
        LogoutTime:currentSSODateTime.toLocaleString(),
        FirstName:Sdata.firstName,
        LastName:Sdata.lastName,
        Email:Sdata.email,
      };
      if (token != null) {
           axios
            .post(`${baseUrl}api/Login/classlink_logout`, requestData, { headers })
            .then((response) => {
              console.log('logout successfull:', response.data);
            })
            .catch((error) => {
              console.error('Failed');
            });
          }
      logout();
      //navigate("/classlink");
      navigate("/classlink", { state: { fromLogout: true } });
      setIsPopoverVisible(false);
    }
    else{
      logout();
      navigate("/");
      setIsPopoverVisible(false);
    }
    
  };

  const handleClickOutside = (event) => {
    const clickedElement = event.target;

    if (popoverRef.current && popoverRef.current.contains(clickedElement)) {
      return;
    }

    if (clickedElement.classList.contains("student-image")) {
      setIsPopoverVisible((prevState) => !prevState);
    } else {
      setIsPopoverVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const savedIcon = localStorage.getItem("profileIcon");
    const bgcolor = localStorage.getItem("bgcolor");

    if (savedIcon) setSelectedIcon(savedIcon);
    if (bgcolor) setBgColor(bgcolor);

}, []);

  const generateInitials = (name) => {
    if (!name) return "";
    const nameParts = name.split(" ");
    const initials = nameParts
      .map((part) => part.charAt(0).toUpperCase())
      .join("");
    return initials.slice(0, 2);
  };

  const [selectedIcon, setSelectedIcon] = useState(generateInitials(studentName));

  const [bgColor, setBgColor] = useState("#ffffff");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="header" style={{ position: 'relative' }}>
      <div className="header-left">
        <p style={{ margin: '0', fontSize: '14px', color: 'white' }}>{currentDateTime}</p>
        <h3>Tango Student Explorer</h3>
      </div>
      <div className="header-right">
      <GoogleTranslate/>
        <img
          src={HelpIcon}
          alt="Help"
          className="help-icon"
          style={{
            cursor: isHelpEnabled ? 'pointer' : 'not-allowed',
            marginRight: '20px',
            width: '50px',
            opacity: isHelpEnabled ? 1 : 0.5,
          }}
          onClick={isHelpEnabled ? handleHelpClick : undefined}
        />
        <div className="icon-container">

          <div
            id="profile-icon"
            className="student-image"
            translate="no"
            onClick={handleImageClick}
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: bgColor,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              overflow: "hidden",
              position: "relative",
            }}
          >
            {uploadedImage ? (
              <img
                src={uploadedImage}
                alt="Profile"
                style={{
                  width: "80%",
                  height: "80%",
                  objectFit: "cover",
                  objectPosition: "center",
                  position: "absolute",

                  pointerEvents: "none"
                }}
              />
            ) : (
              <span
                style={{
                  fontSize: "28px",
                  position: "relative",
                  zIndex: 1,
                  color: "#2D4D93",
                  fontWeight: "bold",
                  pointerEvents: "none"
                }}
              >
                {selectedIcon}
              </span>
            )}
          </div>

          <p className="student-name" translate="no" style={{ marginTop: "0" }}>{studentName}</p>
        </div>

        {isPopoverVisible && (
          <div
            className="popover"
            ref={popoverRef}
            style={{
              position: 'absolute',
              top: '85px',
              right: '0',
              padding: '15px',
              backgroundColor: '#457A23',
              boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              zIndex: '1000',
            }}
          >
            <p translate="no"><strong>Local ID :</strong> {studntIdData} </p>
            <p translate="no"><strong>TSDS ID :</strong> {TsdsStudentIdData} </p>
            <p translate="no"><strong>DOB :</strong> {DOB} </p>
            <p>----------------</p>
            <p className='settings' style={{ cursor: "pointer", height:"25px" }} onClick={openModal}>Settings</p>
            <button
              onClick={handleLogout}
              style={{
                marginTop: '10px',
                padding: '8px 16px',
                backgroundColor: '#2D4D93',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>

      <SettingsPopup
        isOpen={isModalOpen}
        onClose={closeModal}
        selectedIcon={selectedIcon}
        setSelectedIcon={setSelectedIcon}
        bgColor={bgColor}
        setBgColor={setBgColor}
        uploadedImage={uploadedImage}
        setUploadedImage={setUploadedImage}
        studentName={studentName}

      />
    </div>
  );
}

export default Header;
